var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{on:{"click":_vm.setCollapse}},[_c('svg-icon',{staticClass:"hamburger",attrs:{"icon":_vm.isCollapse ? 'hamburger-closed' : 'hamburger-opened'}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }